import React from "react";
import { CircleMarker } from "react-leaflet";
import { useSelector } from "react-redux";

export const EmissionPropCopies = () => {
  const assignedEmissionCopyCoords = useSelector(
    (state) => state.map.assignedEmissionCopyCoords
  );
  return (
    <>
      {assignedEmissionCopyCoords.length !== 0 &&
        assignedEmissionCopyCoords.map((x) => (
          <CircleMarker
            center={x}
            color="red"
            fillColor="white"
            fillOpacity={"1"}
            radius={12}
            dashArray={"12"}
          ></CircleMarker>
        ))}
    </>
  );
};
